import { FC } from 'react';
import { DownloadByTemplateButton, type DownloadTemplateSelection } from '@/entities/download-template';
import { useDownloadExpertReport } from '@/entities/expert-report';

type Props = {
  conversationId: number;
  expertReportId: number;
};

export const DownloadExpertReportButton: FC<Props> = ({ conversationId, expertReportId }) => {
  const { mutate: download, isPending } = useDownloadExpertReport();

  const handleDownload = (selection: DownloadTemplateSelection) => {
    download({ conversationId, expertReportId, ...selection });
  };

  return <DownloadByTemplateButton entityType="EXPERT_REPORT" onDownload={handleDownload} isPending={isPending} />;
};
